var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.9167 1.71429H16.0833V1.14286C16.0833 0.514286 15.5583 0 14.9167 0H9.08334C8.44167 0 7.91667 0.514286 7.91667 1.14286V1.71429H2.08334C1.7625 1.71429 1.5 1.97144 1.5 2.28572V4.00001C1.5 4.31429 1.7625 4.57143 2.08334 4.57143H21.9167C22.2375 4.57143 22.5 4.31429 22.5 4.00001V2.28572C22.5 1.97144 22.2375 1.71429 21.9167 1.71429Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M17.8333 24H6.1667C5.52503 24 5.00002 23.4858 5.00002 22.8572L3.25004 6.85716H20.7501L19 22.8572C19 23.4858 18.475 24 17.8333 24Z","fill":"currentColor","key":1})]);
}

Delete.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Delete;

Delete.default = Delete;
